const DOCUMENT = 'TALENT_ACCREDITAION_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  ADD: DOCUMENT + 'ADD',
  ADD_SUCCESS: DOCUMENT + 'ADD_SUCCESS',
  CREATE: DOCUMENT + 'CREATE',
  TOUCH: DOCUMENT + 'TOUCH',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  save: data => ({
    type: actions.SAVE,
    payload: data,
  }),

  saveSuccess: () => ({
    type: actions.SAVE_SUCCESS,
  }),

  saveError: data => ({
    type: actions.SAVE_ERROR,
    payload: data,
  }),

  add: data => ({
    type: actions.ADD,
    payload: data,
  }),

  addSuccess: () => ({
    type: actions.ADD_SUCCESS,
  }),

  create: data => ({
    type: actions.CREATE,
    payload: data,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),

  loadFormData: data => ({
    type: actions.LOAD_FORM_DATA,
    payload: data,
  }),
};

export default actions;
